import { render, staticRenderFns } from "./PaymentDateValidation.vue?vue&type=template&id=066d661a"
import script from "./PaymentDateValidation.vue?vue&type=script&lang=js"
export * from "./PaymentDateValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports